import { jsx } from "react/jsx-runtime";
import { ModalDialog } from "@zillow/constellation";
import PropTypes from "prop-types";
import React from "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const BlockModalDialog = ({
  attrs,
  innerBlocks,
  index,
  triggerProps
}) => {
  const {
    size = "md",
    ...rest
  } = attrs;
  const body = /* @__PURE__ */ jsx(React.Fragment, { children: generateBlockList({
    blocks: innerBlocks
  }) });
  return /* @__PURE__ */ jsx(ModalDialog, { size, renderBody: body, ...rest, ...triggerProps }, index);
};
BlockModalDialog.propTypes = {
  attrs: PropTypes.shape({
    size: PropTypes.string
  }),
  index: PropTypes.number,
  triggerProps: PropTypes.shape({}),
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
};
export {
  BlockModalDialog as default
};
